import { render, staticRenderFns } from "./DeletedDocuments.vue?vue&type=template&id=99d50cd8"
import script from "./DeletedDocuments.vue?vue&type=script&lang=js"
export * from "./DeletedDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports